/*jshint esversion: 8 */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem("token") || "", // Set token here to Test isLoggedIn
    user: {
      ProfilePicture: "",
      SAPEmpId: 0,
      Teams: [],
      userGroupRights: {
        groupIds: "",
        canAccessUserAdministration: false,
        canAccessProjectAdministration: false,
        canAccessProjects: false,
        canAccessManualTimeManagement: false,
        canAccessTimeManagement: false,
        canAccessPresenceList: false,
        canAccessAdminPresenceList: false,
        canManipulateBookingLines: false,
        canAccessWorkTime: false,
        canAccessWorkTimeTeam: false,
        canAccessManagement: false,
        canAccessAbsenceOverview: false,
        canAccessAbsenceOverviewTeam: false,
        canAccessGeneralReporting: false,
        canAccessGeneralReportingTeam: false
      },
      Name: "",
      needsToChangePassword: false,
      state: null,
      statusInfo: {
        status: "",
        timeAccount: null
      }
    },
    mails: [],
    hasNewMails: false,
    newMailsCount: 0,
    updateMail: false,
    timestamp: null,
    minutePassed: true
  },
  mutations: {
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, response) {
      state.status = "success";
      state.token = response.token;
      state.user = response.user;
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.token = "";
      state.user = {
        ProfilePicture: "",
        SAPEmpId: 0,
        Teams: [],
        userGroupRights: {
          groupIds: "",
          canAccessUserAdministration: false,
          canAccessProjectAdministration: false,
          canAccessProjects: false,
          canAccessManualTimeManagement: false,
          canAccessTimeManagement: false,
          canAccessPresenceList: false,
          canAccessAdminPresenceList: false,
          canManipulateBookingLines: false,
          canAccessWorkTime: false,
          canAccessWorkTimeTeam: false,
          canAccessManagement: false,
          canAccessAbsenceOverview: false,
          canAccessAbsenceOverviewTeam: false,
          canAccessGeneralReporting: false,
          canAccessGeneralReportingTeam: false
        },
        Name: "",
        needsToChangePassword: false,
        statusInfo: {
          status: "",
          timeAccount: null
        }
      };
    },
    setUser(state, userInfo) {
      if (userInfo.user.ProfilePicture == undefined || userInfo.user.ProfilePicture == "") userInfo.user.ProfilePicture = require("@/res/icon/User.jpg");

      state.user = userInfo.user;
      state.token = userInfo.token;
    },
    setUserStatusInfo(state, userInfo) {
      state.user.statusInfo = userInfo;
    },
    setUserId(state, userId) {
      state.user.SAPEmpId = userId;
    },
    setAktiveButton(state, buttons) {},
    getMails(state, mails) {
      state.newMailsCount = 0;
      state.mails = [];
      var onlyOldMails = true;
      for (var i = 0; i < mails.length; i++) {
        if (mails[i].hasRead == 0) {
          onlyOldMails = false;
          state.hasNewMails = true;
          state.newMailsCount++;
        }
      }
      if (onlyOldMails) {
        state.hasNewMails = false;
        state.newMailsCount = 0;
      }
      state.mails = mails;
    },
    updateMail(state, val) {
      state.updateMail = val;
    },
    uploadProfilePicture(state, val) {
      state.ProfilePicture = val;
    },
    setTimestamp(state, val) {
      if (state.timestamp == null) {
        state.timestamp = val;
        state.minutePassed = true;
      } else if (val.diff(state.timestamp, "minutes") > 0) {
        state.timestamp = val;
        state.minutePassed = true;
      } else state.minutePassed = false;
    }
  },
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/login",
            data: user,
            method: "POST"
          })
          .then((resp) => {
            const token = resp.data.token;
            const user = resp.data.user;
            localStorage.setItem("token", token);
            Vue.prototype.$http.defaults.headers.common["Authorization"] = "Bearer " + token;
            commit("auth_success", { token, user });
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    loginPin({ commit }, pin) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/loginPin",
            data: { pin, password: localStorage.getItem("password") },
            method: "POST"
          })
          .then((resp) => {
            if (resp.data.data != undefined && resp.data.data.requestOTPLogin != null && resp.data.data.requestOTPLogin == true) {
              resolve(resp);
            } else {
              const token = resp.data.token;
              const user = resp.data.user;
              localStorage.setItem("token", token);
              Vue.prototype.$http.defaults.headers.common["Authorization"] = "Bearer " + token;
              commit("auth_success", { token, user });
              resolve(resp);
            }
          })
          .catch((err) => {
            commit("auth_error");
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    loginRFID({ commit }, code) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/loginRFID",
            data: { code },
            method: "POST"
          })
          .then((resp) => {
            const token = resp.data.token;
            const user = resp.data.user;
            localStorage.setItem("token", token);
            Vue.prototype.$http.defaults.headers.common["Authorization"] = "Bearer " + token;
            commit("auth_success", { token, user });
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    saveRFID({ commit }, data) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/saveRFID",
            data: { data },
            method: "POST"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    loginOTP({ commit }, otpLoginObject) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/loginOTP",
            data: {
              otpPin: otpLoginObject.otpPin,
              userId: otpLoginObject.userId,
              pin: otpLoginObject.pin
            },
            method: "POST"
          })
          .then((resp) => {
            const token = resp.data.token;
            const user = resp.data.user;
            localStorage.setItem("token", token);
            Vue.prototype.$http.defaults.headers.common["Authorization"] = "Bearer " + token;
            commit("auth_success", { token, user });
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    faceLogin({ commit }, facePicture) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/faceLogin",
            data: facePicture,
            method: "POST"
          })
          .then((resp) => {
            const token = resp.data.token;
            const user = resp.data.user;
            localStorage.setItem("token", token);
            Vue.prototype.$http.defaults.headers.common["Authorization"] = "Bearer " + token;
            commit("auth_success", { token, user });
            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            localStorage.removeItem("token");
            reject(err);
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        commit("logout");
        localStorage.removeItem("token");
        delete Vue.prototype.$http.defaults.headers.common["Authorization"];
        resolve();
        //ToDO:
        reject();
      });
    },
    getTwoFactorStatus({ commit }, userId) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/${userId}/getTwoFactorStatus`,
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    tryEnableTwoFactorAuth({ commit }, userId) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/${userId}/tryEnableTwoFactor`,
            method: "PATCH"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    enableTwoFactorAuth({ commit }, secretAndToken) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/${secretAndToken.userId}/enableTwoFactor/${secretAndToken.token}`,
            data: secretAndToken.secret,
            method: "PATCH"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    disableTwoFactorAuth({ commit }, userId) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/${userId}/disableTwoFactor`,
            method: "POST"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getUserId({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/user/getUserId`,
            method: "GET"
          })
          .then((resp) => {
            let userId = resp.data.data;
            if (resp.data.success) {
              commit("setUserId", userId);
              resolve(resp);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getStatus({ commit, state }, props) {
      commit("setTimestamp", props.timeStamp);
      if (state.minutePassed || state.user.statusInfo == undefined || props.executeImmediately)
        return new Promise((resolve, reject) => {
          Vue.prototype
            .$http({
              url: Vue.prototype.apiUrl + `/api/users/getStatus`,
              method: "GET"
            })
            .then((resp) => {
              let userInfo = resp.data.data;
              if (resp.data.success) {
                localStorage.setItem("token", userInfo.token);
                localStorage.setItem("userStatus", userInfo.user.statusInfo.status);
                Vue.prototype.$http.defaults.headers.common["Authorization"] = "Bearer " + userInfo.token;
                commit("setUser", userInfo);
                resolve(userInfo.user.statusInfo);
              }
            })
            .catch((err) => {
              console.error(err);
            });
        });
      else return null;
    },
    getUserWorkStatus({ commit, state }) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/getUserWorkStatus`,
            method: "GET"
          })
          .then((resp) => {
            let userInfo = resp.data.data.statusInfo;
            if (resp.data.success) {
              commit("setUserStatusInfo", userInfo);
              resolve(resp);
            }
          })
          .catch((err) => {
            console.error(err);
          });
      });
    },
    getStatusDuration({ commit, state }, status) {
      console.log(status);
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/getStatusDuration/${status.userStatus}`,
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    sendStatus({ commit }, newBookingLine) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/sendStatus",
            data: newBookingLine,
            method: "POST"
          })
          .then(async (resp) => {
            let userInfo = resp.data.data.statusInfo;

            if (resp.data.success) {
              commit("setUserStatusInfo", userInfo);
              localStorage.setItem("userStatus", userInfo.status);
            }
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getProjects({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(Vue.prototype.apiUrl + "/api/sapInfo/getProjects")
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getStageProjects({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(Vue.prototype.apiUrl + "/api/sapInfo/getProjectManagements")
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getStageProjectsForMonth({ commit }, date) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(Vue.prototype.apiUrl + `/api/sapInfo/getProjectManagements/${date}`)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getProjectsForUser({ commit }, userId) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(Vue.prototype.apiUrl + `/api/users/${userId}/getProjects`)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getActivityTypes({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(Vue.prototype.apiUrl + "/api/sapInfo/getActivityTypes")
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getProjectManagementActivityTypes({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(Vue.prototype.apiUrl + "/api/sapInfo/getProjectManagementActivityTypes")
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getServiceCalls({ commit }, date) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(Vue.prototype.apiUrl + `/api/sapInfo/getServiceCalls/${date}`)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getServiceTypeList({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(Vue.prototype.apiUrl + "/api/sapInfo/getServiceTypeList")
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getProfitCenters({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(Vue.prototype.apiUrl + "/api/sapInfo/getProfitCenters")
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getMails({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(Vue.prototype.apiUrl + "/api/users/getMails")
          .then((resp) => {
            commit("getMails", resp.data);
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    updateMail({ commit }, mail) {
      commit("updateMail", true);
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/updateMail/" + mail.id,
            data: mail,
            method: "PATCH"
          })
          .then((resp) => {
            commit("updateMail", false);
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            commit("updateMail", false);
            reject(err);
          });
      });
    },
    updateMails({ commit }, mail) {
      //commit("updateMail", true);
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/updateMails",
            data: mail,
            method: "PATCH"
          })
          .then((resp) => {
            //commit("updateMails", false);
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            //commit("updateMails", false);
            reject(err);
          });
      });
    },
    updateProfilePicture({ commit }, picture) {
      let postData = {
        U_profilePicture: picture
      };
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/user/uploadProfilePicture",
            data: postData,
            method: "POST"
          })
          .then((resp) => {
            commit("uploadProfilePicture", postData);
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    setProjectPermissionForUser({ commit }, projects) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/setProjectPermissions/",
            data: projects,
            method: "POST"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getProjectPermissionForUser({ commit }, SAPEmpId) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/getProjectPermissions/" + SAPEmpId,
            method: "GET"
          })
          .then((resp) => {
            if (resp.data.success) {
            }
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    setServiceCallPermissionForUser({ commit }, serviceCalls) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/setServiceCallPermissions/",
            data: serviceCalls,
            method: "POST"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    getServiceCallPermissionForUser({ commit }, SAPEmpId) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/getServiceCallPermissions/" + SAPEmpId,
            method: "GET"
          })
          .then((resp) => {
            if (resp.data.success) {
            }
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getInfoDash({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/getInfoDash/",
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getServiceCallStatusList({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/sapInfo/getServiceCallStatusList/",
            method: "POST"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    deleteInfoDash({ commit }, Code) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/deleteInfoDash/",
            data: Code,
            method: "DELETE"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    setInfoDash({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/setInfoDash/",
            data: data,
            method: "POST"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    setActivityPermissionForUser({ commit }, projects) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/setActivityPermissions/",
            data: projects,
            method: "POST"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    showLoginPin({ commit }, projects) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/user/showLoginPin",
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getActivityPermissionForUser({ commit }, SAPEmpId) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/getActivityPermissions/" + SAPEmpId,
            method: "GET"
          })
          .then((resp) => {
            if (resp.data.success) {
            }
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getBusinessPartners({ commit }) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/sapInfo/getBusinessPartners/`,
            method: "GET"
          })
          .then((resp) => {
            if (resp.data.success) {
            }
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getBusinessPartnersForServiceCalls({ commit }, calls) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/sapInfo/getBusinessPartnersForServiceCalls/`,
            method: "GET",
            data: calls
          })
          .then((resp) => {
            if (resp.data.success) {
            }
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getBusinessPartnersAfterDate({ commit }, date) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/sapInfo/getBusinessPartners/${date}`,
            method: "GET"
          })
          .then((resp) => {
            if (resp.data.success) {
            }
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getServiceTypePermissionForUser({ commit }, SAPEmpId) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/getServiceTypePermissions/" + SAPEmpId,
            method: "GET"
          })
          .then((resp) => {
            if (resp.data.success) {
            }
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getServiceTypePermissionForUserWithPermission({ commit }, SAPEmpId) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + "/api/users/getServiceTypePermissionsWithPermission/" + SAPEmpId,
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getEmployeeInfo({ commit }, SAPEmpId) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/users/getEmployeeInfo/${SAPEmpId}`,
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },

    getInfoForMiniMonthlyOverview({ commit, state }, props) {
      if (state.minutePassed || props.executeImmediately)
        return new Promise((resolve, reject) => {
          Vue.prototype
            .$http({
              url: Vue.prototype.apiUrl + `/api/users/getInfoForMiniMonthlyOverview/${props.SAPEmpId}`,
              method: "GET"
            })
            .then((resp) => {
              resolve(resp);
            })
            .catch((err) => {
              console.log(err);
              reject(err);
            });
        });
    },
    saveState({ commit }, user) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/user/saveState`,
            method: "POST",
            data: user
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    saveManager({ commit }, user) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/user/saveManager`,
            method: "POST",
            data: user
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getWorkModelForUser({ commit }, id) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/user/getWorkModelForUser/${id}`,
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getWorkTimeForDay({}, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/user/${data.userId}/getWorkTimeForDay/${data.date}`,
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    getTimeCorrectionRequestForMessage({}, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/user/getTimeCorrectionRequestForMessage/${data.messageId}/${data.userId}`,
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    sendTimeCorrectionRequest({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/user/sendTimeCorrectionRequest`,
            method: "POST",
            data: data
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    acceptTimeCorrection({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/user/acceptTimeCorrection`,
            method: "POST",
            data: data
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    correctTime({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/user/correctTime`,
            method: "POST",
            data: data
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
    declineTimeCorrection({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/user/declineTimeCorrection`,
            method: "POST",
            data: data
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getTimeAccountCorrectionsForDate({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/user/getTimeAccountCorrectionForDate/${data.userId}/${data.date}`,
            method: "GET"
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    correctTimeAccount({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/user/correctTimeAccount`,
            method: "POST",
            data: data
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    sendAutomaticCloseOpenBookingMessage({ commit }, data) {
      return new Promise((resolve, reject) => {
        Vue.prototype
          .$http({
            url: Vue.prototype.apiUrl + `/api/user/sendAutomaticCloseOpenBookingMessage`,
            method: "POST",
            data: data
          })
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  },
  modules: {},
  getters: {
    isLoggedIn: (state) => !!state.token,
    authStatus: (state) => state.status,
    user: (state) => state.user,
    mails: (state) => state.mails,
    hasNewMails: (state) => state.hasNewMails,
    newMailsCount: (state) => state.newMailsCount,
    profilePicture: (state) => state.user.ProfilePicture
  }
};
